import { StatusContainer } from '@servicetitan/financing-utils-shared';
import { LoanDetails } from '../decision';
import UnderReviewIllustration from '../../common/illustrations/updating.svg';

export const UnderReviewSign = () => {
    return (
        <StatusContainer
            headline="Your loan document is under review"
            message="Contact Service Finance at info@svcfin.com or (866) 254-0497 for more information."
            image={UnderReviewIllustration}
        >
            <LoanDetails />
        </StatusContainer>
    );
};
